import { render, staticRenderFns } from "./ranklist.vue?vue&type=template&id=b0cf764a&scoped=true&"
import script from "./ranklist.vue?vue&type=script&lang=js&"
export * from "./ranklist.vue?vue&type=script&lang=js&"
import style0 from "./ranklist.vue?vue&type=style&index=0&id=b0cf764a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cf764a",
  null
  
)

export default component.exports